import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function DialogRegisterModal({open, onClose}) {

  const handleClose = (e) => {
    onClose?.(e);
  };

  const handleClickOpen = () => {
    const newWindow = window.open('https://my.inexplore.com', '_blank', 'noopener,noreferrer')
	  if (newWindow) newWindow.opener = null
  };

  return (
      <BootstrapDialog
        onClose={(e) => {
          handleClose(e);
        }}
        aria-labelledby="customized-dialog-title"
        open={!!open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Création de compte
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={(e) => {
						handleClose(e);
					}}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            La création d'un compte Inexploré et votre consentement à l'utilisation de vos données personnelles sont nécessaires avant inscription
             à cette newsletter.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClickOpen}>
            Créer un compte
          </Button>
        </DialogActions>
      </BootstrapDialog>
  );
}